import React, { useEffect, useRef, useState } from "react";
import { FiRefreshCw, FiSearch, FiChevronDown } from "react-icons/fi";

import { getRepresentatives } from "./RepresentativeSettlementService";

const Representatives = ({
  selectedRepresentative,
  onSelectRepresentative,
  selectedDate,
  onDateChange,
  onRefresh,
}) => {
  const [representatives, setRepresentatives] = useState([]);
  const [loading, setLoading] = useState(false);

  // -- بحث المندوب --
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const wrapperRef = useRef(null);

  const loadRepresentatives = async () => {
    try {
      setLoading(true);

      const response = await getRepresentatives();

      const data = Array.isArray(response)
        ? response
        : response?.data || [];

      setRepresentatives(data);
    } catch (error) {
      console.error("get representatives error:", error);
      setRepresentatives([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRepresentatives();
  }, []);

  // إغلاق القائمة عند الضغط برة الصندوق
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // نفس اللوجيك القديم بالظبط: onSelectRepresentative بياخد الـ representative أو null
  const handleSelect = (representative) => {
    onSelectRepresentative(representative || null);
    setSearchTerm("");
    setIsOpen(false);
  };

  const handleRefresh = async () => {
    await loadRepresentatives();

    if (onRefresh) {
      onRefresh();
    }
  };

  const filteredRepresentatives = representatives.filter(
    (representative) =>
      (representative.fullName || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
  );

  return (
    <div className="representative-controls no-print">
      {/* المندوب */}
      <div
        className="representative-control representative-control-representative"
        ref={wrapperRef}
      >
        <label>المندوب</label>

        <div className="representative-select-wrapper">
          <div
            className="representative-search-wrapper"
            onClick={() => setIsOpen(true)}
          >
            <FiSearch size={14} />

            <input
              type="text"
              placeholder={
                loading ? "جاري التحميل..." : "ابحث عن مندوب..."
              }
              value={
                isOpen
                  ? searchTerm
                  : selectedRepresentative?.fullName || ""
              }
              onChange={(event) => {
                setSearchTerm(event.target.value);
                setIsOpen(true);
              }}
              onFocus={() => {
                setIsOpen(true);
                setSearchTerm("");
              }}
              disabled={loading}
            />

            <FiChevronDown size={14} />
          </div>

          {isOpen && (
            <div className="representative-dropdown">
              {filteredRepresentatives.length === 0 ? (
                <div className="representative-dropdown-empty">
                  لا يوجد نتائج
                </div>
              ) : (
                filteredRepresentatives.map((representative) => (
                  <div
                    key={representative.id}
                    className={`representative-dropdown-item${
                      selectedRepresentative?.id === representative.id
                        ? " active"
                        : ""
                    }`}
                    onClick={() => handleSelect(representative)}
                  >
                    {representative.fullName}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>

      {/* التاريخ */}
      <div className="representative-control representative-control-date">
        <label>التاريخ</label>

        <input
          type="date"
          value={selectedDate}
          onChange={(event) => onDateChange(event.target.value)}
        />
      </div>

      {/* تحديث */}
      <button
        type="button"
        className="refresh-button"
        onClick={handleRefresh}
        disabled={loading}
      >
        <FiRefreshCw size={15} />
        تحديث
      </button>
    </div>
  );
};

export default Representatives;